

















import Vue from "vue";

// Import External Components
import LayoutSection from "@miele/component-library-vue/src/components/layouts/LayoutSection.vue";
import QuickEntry from "@miele/component-library-vue/src/components/modules/slider/quick-entry/QuickEntry.vue";
import QuickEntrySlide from "@miele/component-library-vue/src/components/modules/slider/quick-entry/QuickEntrySlide.vue";

export default Vue.extend({
  name: "CollectionContainer",
  computed: {
    collections() {
      return this.$store.getters.getCollections;
    },
    slidesPerView() {
      return Number(this.$store.state.config.slidesPerView);
    },
  },
  components: {
    QuickEntry,
    QuickEntrySlide,
    LayoutSection,
  },
  methods: {
    clickFunction(slide: any, e: MouseEvent) {
      this.$router.push({
        name: "Collection",
        params: {
          title: slide.name,
          id: slide.id,
          slug: slide.name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
        },
      });
      e.preventDefault();
    },
  },
});
